module.exports = __webpack_public_path__ + "img/ico_copy.cd494e30.svg";